const THEME_KEY = 'tx_theme';

export function getTheme() {
  if (typeof window === 'undefined') return 'dark';
  try {
    const stored = window.localStorage.getItem(THEME_KEY);
    return stored === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function setTheme(value) {
  if (typeof window === 'undefined') return;
  try {
    if (value === 'light' || value === 'dark') {
      window.localStorage.setItem(THEME_KEY, value);
    }
  } catch {
    // ignore
  }
}
